import { render, staticRenderFns } from "./TextIndent.vue?vue&type=template&id=0eb1f358"
import script from "./TextIndent.vue?vue&type=script&lang=js"
export * from "./TextIndent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports